<div [formGroup]="form">

  <!-- Cardholder Name -->
  <div class="input-container">
    <span class="input-label">Cardholder Name</span>
    <input
      type="text"
      class="input"
      formControlName="cardholderName"
    >
    <span
      class="error"
      *ngIf="f.cardholderName.touched && f.cardholderName.value === ''"
    >Please enter cardholder name.</span>
  </div>
  <!-- ZIP/Postal Code -->
    <div class="input-container">
      <div class="input-container">
        <span class="input-label">Nickname</span>
        <input
          type="text"
          class="input"
          formControlName="cardNickname"
        >
      </div>
  <!-- ZIP/Postal Code -->
  <!-- <div class="input-container">
    <span class="input-label">ZIP/Postal Code</span>
    <input
      type="text"
      class="input"
      formControlName="postalCode"
    >
    <span
      class="error"
      *ngIf="f.postalCode.touched && f.postalCode.value === ''"
    >Please enter a ZIP or postal code.</span>
    <span
      class="error"
      *ngIf="f.postalCode.dirty && form.hasError('postalCode') && f.postalCode.value !== ''"
    >Invalid ZIP or postal code format.</span>
  </div> -->

  <ng-container *ngIf="isEditMode">
    <!-- Credit Card Number -->
    <div class="input-container">
      <span class="input-label">Credit Card Number</span>
      <input
        type="text"
        class="input disabled"
        formControlName="creditCardNumber"
        [attr.disabled]="''"
      >
    </div>
    <!-- Expiration Date -->
    <div class="dropdown input-container">
      <span class="input-label">Expiration Date</span>
      <div class="row no-gutters">
        <div class="col month-container">
          <mat-form-field class="input">
            <mat-select formControlName="expMonth">
              <mat-option
                *ngFor="let month of monthList"
                [value]="month"
              >{{ month }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field class="input">
            <mat-select formControlName="expYear">
              <mat-option
                *ngFor="let year of yearList"
                [value]="year"
              >{{ year }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <!-- CVV -->
    <!-- <div class="input-container">
      <span class="input-label">CVV</span>
      <input
        type="text"
        class="input disabled"
        formControlName="cvv"
        [attr.disabled]="''"
      >
    </div> -->
  </ng-container>

  <!-- "Add Mode" -->
  <ng-container *ngIf="!isEditMode">
    <div class="card-info-container">
      <span class="card-info-label">Card Information</span>
    </div>
    <iframe
      #iframe
      class="card-iframe"
      id="iframe"
      frameBorder="0"
      (load)="iframeOnLoad()"
    ></iframe>
  </ng-container>

</div>
